import React from "react";
import Prism from "prismjs";
import "prismjs/components/prism-python";

interface PythonCodeBlockProps {
  code: string;
  maxHeight?: string;
}

const PythonCodeBlock: React.FC<PythonCodeBlockProps> = ({
  code,
  maxHeight = "12rem",
}) => {
  const html = Prism.highlight(code, Prism.languages.python, "python");

  return (
    <div
      className="reward-editor-wrapper rounded-lg overflow-auto"
      style={{ maxHeight }}
    >
      <pre
        className="reward-editor p-4 m-0 text-xs"
        style={{
          fontFamily:
            "\"Fira Code\", \"JetBrains Mono\", \"Cascadia Code\", monospace",
          lineHeight: 1.6,
        }}
      >
        <code dangerouslySetInnerHTML={{ __html: html }} />
      </pre>
    </div>
  );
};

export default PythonCodeBlock;
